import { digitsEnToFa, digitsFaToEn } from 'persian-tools2';
import jMoment from 'jalali-moment';
import persianDate from 'persian-date';
import moment from 'jalali-moment';

const recognizePublishMode = (string) => {
  switch (string) {
    case 'development':
      return {
        name: 'DEVELOPMENT',
        url: process.env.REACT_APP_BASE_URL,
        calculatorURL: process.env.REACT_APP_CALCULATOR_BASE_URL
      };
    case 'production':
      return { name: 'PRODUCTION', url: process.env.REACT_APP_BASE_URL };
    case 'release':
      return {
        name: 'RELEASE',
        url: process.env.REACT_APP_BASE_URL,
        calculatorURL: process.env.REACT_APP_CALCULATOR_BASE_URL
      };
    default:
      return null;
  }
};

export const PUBLISH_MODE = recognizePublishMode(
  process.env.REACT_APP_PUBLISH_MODE
);

export const validateMedicalNumber = (value) => {
  let error;
  if (!value) {
    error = 'لطفا شماره نظام پزشکی خود را وارد کنید';
  }
  // else if (value.length < 6) {
  //     error = "لطفا شماره نظام پزشکی خود را کامل وارد کنید";
  // }
  // else if (value.length > 4) {
  //     error = "شماره نظام پزشکی شما صحیح نیست";
  // }
  return error;
};

export const validateCode = (value) => {
  let error;
  if (!value) {
    error = 'لطفا کد ارسال شده به تلفن همراه خود را وارد کنید';
  } else if (value.length !== 4) {
    error = 'لطفا کد را به صورت کامل وارد کنید';
  }
  return error;
};

export const validateMobileNumber = (value) => {
  let error = false;
  const num = digitsFaToEn(value);
  if (!/^(09)\d{9}$/i.test(num)) {
    error = 'شماره تلفن باید با ۰۹ شروع شود و ۱۱ رقم باشد ';
  }
  return error;
};

export const validateBirthDate = (value) => {
  // regext === (Year: 1300-1499)-(Month: 1-12 and 01-12)-(Day: 1-31 and 01-31)
  const validBirthDate =
    /^1[34][0-9][0-9]\/(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])$/i.test(
      value
    );
  let error;
  if (value === '') {
    error = 'لطفا تاریخ تولد خود را وارد کنید';
  }
  if (validBirthDate === false) {
    error = 'تاریخ تولد شما صحیح نمی باشد';
  }
  return error;
};

export const validateGender = (value) => {
  let error;
  if (value === null) {
    error = 'لطفا جنسیت خود را انتخاب کنید';
  }
  return error;
};

export const patientDiabetType = (type) => {
  const diabetType =
    type === 0
      ? 'دیابت نوع یک'
      : type === 1
      ? 'دیابت نوع دو'
      : type === 2
      ? 'دیابت بارداری'
      : type === 4
      ? 'پیش دیابت'
      : type === 3
      ? 'نامشخص'
      : '';
  return diabetType;
};

export const validateDiabetType = (value) => {
  let error;
  if (value === null) {
    error = 'لطفا نوع دیابت خود را انتخاب کنید';
  }
  return error;
};

export const patientInsulinType = (type) => {
  return type === 1
    ? '2 مرتبه در روز یا کمتر'
    : type === 2
    ? '3 مرتبه در روز یا بیشتر'
    : type === 0
    ? 'خیر'
    : '';
};
export const patientPregnancyType = (type) => {
  return type === true ? 'باردار است' : 'باردار نیست';
};

export const convert_number = (digit) => {
  digit = digit?.toString();
  // return str_replace(range(0, 9), array('۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'), $num);
  return digit?.replace(/[\u06F0-\u06F9]+/g, function (digit) {
    let ret = '';
    for (let i = 0, len = digit.length; i < len; i++) {
      ret += String?.fromCharCode(digit.charCodeAt(i) - 1728);
    }

    return ret;
  });
};

export const validateNationalNumber = (value) => {
  let error = null;
  if (!value) {
    error = 'لطفا کد ملی خود را وارد کنید';
  } else if (!/^\d{10}$/.test(value)) {
    error = 'فرمت کد ملی صحیح نمی باشد';
  } else {
    const check = +value[9];
    const sum =
      value
        .split('')
        .slice(0, 9)
        .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
    const result = sum < 2 ? check === sum : check + sum === 11;
    if (!result) error = 'فرمت کد ملی صحیح نمی باشد';
  }
  return error;
};

export const validateName = (value, field) => {
  let error = null;
  let p =
    /^[\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\u0629\u0643\u0649-\u064B\u064D\u06D5\s ]+$/;

  if (!value) {
    error = `لطفا ${field} خود را وارد کنید`;
  } else if (!p.test(value)) {
    error = `${field} خود را فارسی وارد کنید`;
  }
  return error;
};

export const validateAge = (value) => {
  let error;
  value = convert_number(value);
  if (!value) {
    error = 'لطفا سن خود را وارد کنید';
  } else if (!/^[0-9]+$/i.test(value)) {
    error = 'سن باید عدد باشد';
  }
  return error;
};

export const year = () => {
  let years = [];
  const thisYear = moment().locale('fa').format('YYYY');
  for (let i = 1300; i <= thisYear; i++) {
    years.push({ value: i.toString(), id: i.toString() });
  }
  return years;
};

export const convertIsoToPersian = (value) => {
  let options = { month: 'long', day: 'numeric' };
  let date = new Date(value).toLocaleDateString('fa-IR', options);
  return date;
};

export const convertDate = (value) => {
  let moment = jMoment(value, 'jYYYY/jM/jD'); /*e.g => 1400/03/04 */
  moment.locale('fa');
  // const year = moment.jYear();        /* e.g => yearDigit = 1400 */
  // const month = moment.jMonth() + 1; /*e.g => monthnDigit = 10  */
  // const day = moment.jDate();       /* e.g => day = 16 */
  const fullDateLong = moment.format('dddd jD jMMMM'); /* شنبه 5 مهر */

  return {
    //  year, month, day,
    fullDateLong
  };
};

// output is دوشنبه 12تیر 1402
export const datePersianFormat = (jalaliDate) => {
  const dateValue = jalaliDate.split(/\s+/)[0].split('/');
  let dateFormat = new persianDate([
    parseInt(dateValue[0]),
    parseInt(dateValue[1]),
    parseInt(dateValue[2])
  ]);
  return (
    dateFormat.format('dddd') +
    ' ' +
    dateValue[2] +
    ' ' +
    dateFormat.format('MMMM') +
    ' ' +
    dateValue[0]
  );
};

export const formatingInitialValue = (value) => {
  let moment = jMoment(digitsFaToEn(value), 'jYYYY/jM/jD');
  const year = moment.jYear();
  const month = moment.jMonth() + 1;
  const day = moment.jDate();
  return { year, month, day };
};

export const whatsappUrl = 'https://wa.link/zatrmp';
export const rayChatUrl =
  'https://widget.raychat.io/64e4741d9d5ee8c0bd2f3bb2?version=2';

export const validateSharePhoneNumber = (value) => {
  let error;
  const num = digitsFaToEn(value);
  if (!/^(09)\d{9}$/i.test(num)) {
    error = '*شماره تلفن باید با 09 شروع شود و 11 رقم باشد.';
  }
  return error;
};

export const options = {
  weekday: 'long',
  day: 'numeric',
  month: 'long'
};
export const yearOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
};
export const timeOptions = {
  hourCycle: 'h24',
  hour: '2-digit',
  minute: '2-digit'
};
export const time12hOptions = {
  hourCycle: 'h12',
  hour: '2-digit',
  minute: '2-digit'
};

export const daysArray = () => {
  const days = [];

  for (let i = 1; i < 32; i++) {
    days.push({ id: i.toString(), value: digitsEnToFa(i.toString()) });
  }
  return days;
};

export const addEventListener = (type, func) => {
  //for android listener
  document.addEventListener(type, func);
  //for ios listener
  window.addEventListener(type, func);
};
export const removeEventListener = (type, func) => {
  document.removeEventListener(type, func);
  window.removeEventListener(type, func);
};

// const useNavigateToReport = (id) => {
//     const navigate = useNavigate();
//     return navigate('/app/report', {state: {patientId: id}});
// };

// export {
//     useNavigateToReport
// };

function areStringsEqual(str1, str2) {
  if (str1?.length !== str2?.length) {
    return false; // Different lengths, can't be equal
  }
  for (let i = 0; i < str1?.length; i++) {
    if (str1[i] !== str2[i]) {
      return false; // Found a character that is different
    }
  }
  return true; // All characters are equal
}

export { areStringsEqual };

export const convertWeekDay = (value) => {
  const timestamp = new Date(value);
  // week day سه شنبه و ..
  return new Intl.DateTimeFormat('fa-IR', { weekday: 'long' }).format(
    timestamp
  );
};
export const convertDateNumeric = (value) => {
  const timestamp = new Date(value);
  // year date 1400/1/1
  return new Intl.DateTimeFormat('fa-IR', yearOptions).format(timestamp);
};
